import clsx from "clsx";
import { useTranslation } from "react-i18next";
// import { useShallow } from "zustand/react/shallow";

import logo from "@/assets/images/logo.svg";
import { Typography } from "@atoms/typography";
import { FastButton } from "@components/fastFields/fastButton";
// import { useAuthStore } from "@templates/authManagement/authStore";

import classes from "./styles.module.scss";

export function AuthHeader() {
  // const step = useAuthStore(useShallow((state) => state.step));
  const { t } = useTranslation(["common", "page"]);

  return (
    <div className={clsx(classes.header)}>
      <img src={logo} alt={"logo"} className={clsx(classes.header__logo)} />
      <div className={clsx(classes.header__actions)}>
        <Typography fontType={"paragraph-small"} themeColor={"text-strong-900"}>
          {t("needHelp")}
        </Typography>
        <FastButton type={"whatsUp"} />
      </div>
    </div>
  );
}
